import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { api } from '../lib/api';

// Auto-scrolling "How it works & Why us" strip.
// Duplicates items for seamless loop, pauses on hover.
const WhyUsMarquee = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get('/why-us').then((r) => setItems(r.data)).catch(() => {});
    }, []);

    if (!items || items.length === 0) return null;
    const looped = [...items, ...items];

    return (
        <section
            className="border-y border-white/10 bg-[#0C0C0C] py-24 md:py-28 overflow-hidden"
            data-testid="why-us-section"
        >
            <div className="container-page flex items-end justify-between gap-6 mb-14 flex-wrap">
                <div>
                    <div className="label-caps text-brand-primary mb-4">/ How it works &amp; why us</div>
                    <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl">
                        Six reasons<br />industrial teams call us first.
                    </h2>
                </div>
                <p className="max-w-md text-white/60 text-sm">
                    Why operators buy, rent and train with Dry Ice Bulls.
                </p>
            </div>

            <div className="relative group">
                <div
                    className="flex gap-6 whitespace-nowrap animate-testimonials-scroll group-hover:[animation-play-state:paused]"
                    style={{ width: 'max-content' }}
                    data-testid="why-us-track"
                >
                    {looped.map((w, i) => (
                        <WhyUsCard w={w} key={`${w.id}-${i}`} idx={i % items.length} />
                    ))}
                </div>

                <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-[#0C0C0C] to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-[#0C0C0C] to-transparent" />
            </div>
        </section>
    );
};

const WhyUsCard = ({ w, idx }) => (
    <article
        className="w-[24rem] md:w-[30rem] flex-shrink-0 border border-white/10 bg-brand-bg p-8 md:p-10 whitespace-normal hover:border-brand-primary transition-colors flex flex-col"
        data-testid={`why-us-card-${idx}`}
    >
        <CheckCircle2 className="h-7 w-7 text-brand-primary mb-6" strokeWidth={1.5} />
        <h3 className="font-display font-black uppercase tracking-tight text-xl md:text-2xl leading-tight text-white">
            {w.title}
        </h3>
        <p className="mt-5 text-sm md:text-[15px] text-white/70 leading-relaxed">
            {w.description}
        </p>
    </article>
);

export default WhyUsMarquee;
